import { useEffect, useState } from 'react'
import { subscribeToReviewStats, type ReviewStat } from './firebase'

export interface ProductReviewSummary {
  /** Average star rating, 0 when there are no reviews. */
  avg: number
  /** Number of reviews. */
  count: number
}

/**
 * Live map of productId -> { avg, count } derived from real, verified-purchase
 * reviews. Empty until customers start reviewing, so a new site shows 0s.
 */
export function useReviewStats(): Record<string, ProductReviewSummary> {
  const [stats, setStats] = useState<Record<string, ReviewStat>>({})

  useEffect(() => {
    const unsub = subscribeToReviewStats(setStats)
    return unsub
  }, [])

  const summary: Record<string, ProductReviewSummary> = {}
  for (const [productId, { sum, count }] of Object.entries(stats)) {
    summary[productId] = {
      avg: count > 0 ? sum / count : 0,
      count,
    }
  }
  return summary
}
